import $ from 'jquery'
import Masonry from 'masonry-layout'
import Swiper from 'swiper/bundle'

const initializeBlock = function ($block) {
  const wrapper = $block.find('.achievements-block__masonry')
  const feedWrapper = $block.find('.achievements-block__feed-wrapper')

  let masonry,
    swiper,
    masonryActive = false,
    swiperActive = false

  const masonryInit = () => {
    masonry = new Masonry(wrapper[0], {
      itemSelector: '.feed-achievement',
      columnWidth: '.achievements-block__sizer',
      percentPosition: true,
    })
  }

  const swiperInit = () => {
    swiper = new Swiper(feedWrapper[0], {
      slidesPerView: 1.2,
      spaceBetween: 15,
      wrapperClass: 'achievements-block__masonry',
      slideClass: 'feed-achievement',
      breakpoints: {
        576: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 2.3,
          spaceBetween: 30,
        },
      },
    })
  }

  const autoInit = () => {
    if (window.matchMedia('(max-width: 1199px)').matches) {
      // masonry destroy
      if (undefined !== masonry) {
        masonry.destroy()
        masonryActive = false
      }

      // swiper init
      if (!swiperActive) {
        swiperInit()
        swiperActive = true
      }
    } else {
      // swiper destroy
      if (undefined !== swiper) {
        swiper.destroy()
        swiperActive = false
      }

      // masonry init
      if (!masonryActive) {
        masonryInit()
        masonryActive = true
      }
    }
  }

  window.onresize = autoInit
  autoInit()
}

$('.achievements-block').each(function () {
  initializeBlock($(this))
})

if (window.acf) {
  window.acf.addAction(
    'render_block_preview/type=vn-achievements',
    initializeBlock
  )
}
